import { ExpectedProps } from '@lib/factory/serverprops';
import { NextPage } from 'next';
import React from 'react';
import { PageLayout } from '@components/PageLayout/PageLayout';
import s from './withdrawPage.module.scss';
import cn from 'classnames';
import { useTranslation } from '@hooks/useTranslation';
import { Breadcrumb } from '@components/UIKit/Breadcrumb/Breadcrumb';
import { Form } from '@components/Pages/PaymentsPages/Withdraw/Form/Form';
interface PageProps extends ExpectedProps {}
const Page: NextPage<PageProps> = ({}) => {
  const {
    translate: tr
  } = useTranslation();
  return <PageLayout showBackIconOnMobile data-sentry-element="PageLayout" data-sentry-component="Page" data-sentry-source-file="index.tsx">
            <div className={s.withdrawPage}>
                <div className={cn(s.withdrawPage__container, '_container')}>
                    <Breadcrumb data-sentry-element="Breadcrumb" data-sentry-source-file="index.tsx" />
                    <h1 className={cn(s.withdrawPage__title, '_title')}>
                        {tr({
            id: 'withdraw.page.title'
          })}
                    </h1>
                    <Form data-sentry-element="Form" data-sentry-source-file="index.tsx" />
                </div>
            </div>
        </PageLayout>;
};
export default Page;